import axiosInstance from "./axiosInstance"

export function getCategories() {
    return new Promise((resolve, reject) => {
        axiosInstance.get("/category").then(res => resolve(res.data.data, res.data.count)).then(e => reject(e));
    })
}

export function getPagenatedCategories(page = 1) {
    return new Promise((resolve, reject) => {
        axiosInstance.get("/category", {
            params: {
                page,
            }
        }).then(res => resolve(res.data.data, res.data.count)).then(e => reject(e));
    })
}

export function CheckCategory(categoryId, data) {

    return new Promise((resolve, reject) => {
        axiosInstance.post(`/check_category/${categoryId}`, data).then(res => resolve(res.data)).then(e => reject(e));
    });

}


